import React, { Component, PropTypes } from 'react';
import capitalize from 'lodash/capitalize';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { CheckBoxField } from 'common/components/form_fields';
import ModalDialog from 'common/components/modal/modal_dialog';
import AnimatedButton from 'common/components/animated_button';

let Form = ({
  error, handleSubmit, submitting, submitFailed, onClose, name, description,
  checklist, confirmation, disclaimer
}) => {
  const checklistItems = (checklist || '').split('\n').filter(i => i);

  return (
    <form onSubmit={handleSubmit}>
      <h2>Approve your { name }</h2>

      { description }

      { checklistItems.length > 0 &&
      <div className="checklist">
        <label>{ capitalize(name) } checklist:</label>
        <ul>
          { checklistItems.map((item, i) => <li key={i}>- {item}</li>) }
        </ul>
      </div> }

      { disclaimer && <p className="disclaimer">{ disclaimer } </p> }

      { confirmation &&
      <fieldset>
        <Field name="confirmation" label={confirmation} component={CheckBoxField} />
      </fieldset> }

      <div className="modal-actions">
        <AnimatedButton processing={submitting} type="submit"
          label={`Approve ${name}`} processingLabel="Approving..." errorMsg={error || submitFailed}
          successMsg="Done!" baseBtnClass="btn btn-success btn-block"/>

        <button className="btn btn-text btn-block" onClick={onClose}>Cancel</button>
      </div>
    </form>
  );
}

const validate = (values, { confirmation }) => {
  /* if provided, make sure confirmation is checked */
  if (confirmation && !values.confirmation) {
    return { confirmation: 'Please confirm before proceeding.' };
  }
}

Form = reduxForm({
  form: "ApproveModal",
  validate
})(Form);

export default class ApproveModal extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const {
      approveRequest, wrapup, onClose, onDone, fetchWrapupsIfNeeded, fetchMessagesIfNeeded,
      name
    } = this.props;

    let wrapupStep = '';
    if (name === 'name') {
      wrapupStep = 'approve_name';
    } else if (name === 'proofs') {
      wrapupStep = 'approve_proofs';
    } else if (name === 'final files') {
      wrapupStep = 'approve_files';
    }

    return approveRequest(wrapup.award.id).then(() => {
      /* reload wrapups and messages, close modal and invoke `onDone` callback if provided */
      fetchWrapupsIfNeeded(wrapup.project_id, true);

      fetchMessagesIfNeeded({
        force: true,
        wrapupStep,
        wrapup
      });

      onClose();

      if (onDone) {
        onDone();
      }
    }).catch((res) => {
      /* global error */
      throw new SubmissionError({ _error: 'Failed to approve resources. Please try again.' });
    });
  }

  render() {
    const { name, onClose } = this.props;

    return (
      <ModalDialog
        modalOpen={true}
        dialogClasses="approve-modal"
        closeAction={onClose}
        modalHeader={`Approve ${name}`}
      >
        <Form {...this.props} onSubmit={this.handleSubmit} />
      </ModalDialog>
    );
  }
}

ApproveModal.propTypes = {
  name: PropTypes.string.isRequired,
  approveRequest: PropTypes.func.isRequired,
  wrapup: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onDone: PropTypes.func,
  fetchWrapupsIfNeeded: PropTypes.func.isRequired,
  fetchMessagesIfNeeded: PropTypes.func.isRequired,
  description: PropTypes.node,
  checklist: PropTypes.string,
  confirmation: PropTypes.string,
  disclaimer: PropTypes.string,
};



// WEBPACK FOOTER //
// ./project/components/wrapup/approve_modal.jsx